import _ from '../../utils';
import frameworkAdapter from './adapters/jsonschemaAdapter';
import IValidationError from './IValidationError';
import { IJSONSchema } from './IJSONSchema';
import ValidationTranslator from './validationTranslator';

export default class Validation {
  readonly REF_PREFIX = '$ref:';

  public validate(schema: IJSONSchema, object: any, propName?: string): IValidationError[] {
    let mappedErrors = frameworkAdapter.validate(schema, object);
    mappedErrors.forEach((error, index) => {
      const propSchema = this.getPropertySchema(schema, error.path);
      error.message = ValidationTranslator.generateMessage(schema, error);
      error.label = propSchema?.title;
      error.description = propSchema?.description;
      mappedErrors[index] = this.validateSameAs(schema, object, error)!;
    });
    mappedErrors = mappedErrors.filter((error) => error !== undefined && error !== null);
    if (propName) {
      mappedErrors = mappedErrors.filter((error: any) => {
        return error.propName === propName || error.path?.join('.') === propName;
        // || this.getPatternReference(error) === propName;
      });
    }

    mappedErrors = this.sortErrors(mappedErrors);
    return mappedErrors;
  }

  /** Sort according to sort prop or if that is not available by the property name.
   * This method does **not** mutate the passed array and returns a new sorted instance. */
  public sortErrors(errors: IValidationError[]) {
    if (!_.isArray(errors)) {
      return errors;
    }
    return [...errors].sort((a, b) => {
      if (a.sort === undefined && b.sort === undefined) {
        if (a.propName) {
          return a.propName.localeCompare(b.propName as string);
        }
      }
      if (typeof a.sort === 'string') {
        return a.sort.localeCompare(b.sort as string);
      }
      return a.sort! - (b.sort as number);
    });
  }

  public getPatternReference(error:IValidationError) {
    const { pattern } = error.params ?? {};
    let ref;
    if (pattern && pattern.startsWith(this.REF_PREFIX)) {
      ref = pattern.substring(this.REF_PREFIX.length, pattern.length);
    }
    return ref;
  }

  validateSameAs(schema: IJSONSchema, object: any, error: IValidationError) {
    const ref = this.getPatternReference(error);
    if (ref) {
      const pathObj = [...error.path];
      pathObj.pop();
      const pathString = [...pathObj, ref].join('.');
      const refValue = _.deepGet(object, pathString);
      const value = _.deepGet(object, error.path.join('.'));
      // const refSchema = this.getPropertySchema(schema, [...pathObj, ref]);
      // const refTitle = refSchema?.title;
      if (refValue !== value) {
        // const message = Vue.$t('core.validation.sameAs', refTitle);
        return error as IValidationError;
      }
      return undefined;
    }
    return error;
  }

  public getPropertySchema(schema: IJSONSchema, propPath: string[]): IJSONSchema | undefined {
    if (schema && (schema.type === 'object' && _.isObject(schema.properties))) {
      const clonedPath = [...propPath];
      const propName = clonedPath.shift()!;
      const property = schema.properties[propName];
      if (_.isObject(property)) {
        if (property.type === 'object' && clonedPath.length > 0) {
          return this.getPropertySchema(property, clonedPath);
        }
        return property;
      }
    }
    return undefined;
  }
}
